















import Vue from 'vue'
import Component from 'vue-class-component'
import { Emit, Prop, Watch } from 'vue-property-decorator'
import Listing from '@/views/dashboard/projects/Listing.vue'
import Project from '@/models/Project'
import { GetHiddenProjects, UnhideProject, IsProjectHidden } from '@/util/LocalProjectHiding'
import { mapGetters } from 'vuex'

@Component({
	components: 
	{
		Listing
	},
	computed: 
	{
		...mapGetters([
			'projects'
		])
	},
	recomputed:{
		hiddenProjects()
		{
			let self = this as HiddenProjectList;
			return self.projectList.filter((p)=>IsProjectHidden(p));//.map((p) => { return (this as any).projects.get(p.id); });
		}
	}
})
export default class HiddenProjectList extends Vue 
{
	generation = 0;

	get projectList() : Project[]
	{
		let src = (this as any).projects.values();
		let res = [];
		for(let p of src)
		{
			res.push(p as Project);
		}

		res.sort((a : any, b : any) => 
		{
			// numeric == natural sort, base sensitivity == case insensitive
			return a.name.trim().localeCompare(b.name.trim(), undefined, {numeric: true, sensitivity: 'base'});
		});
		return res;
	}

	refresh()
	{
		++this.generation;
		console.log(`refresh! ${this.generation}`);
		this.$recompute('hiddenProjectList');
		this.$forceUpdate();
	}
}
